export enum FuncionalidadeEnum {
  Master_Usuario = 1,
  Master_Perfil = 2,
  InteligenciaDados_MeusRelatorios = 4,
  InteligenciaDados_ConfigurarRelatorio = 5,
  Desenvolvedor_Logs = 6,
  Desenvolvedor_CategoriaArquivo = 18,
  Desenvolvedor_Arquivo = 19,
  Desenvolvedor_TabelaIbpt = 23,
  Tintas_Fabricante = 7,
  Suporte_SuperAcesso = 10,
  Implantacao_Empresa = 20,
  Implantacao_GrupoEmpresa = 21,
  Suporte_Notificacao = 22,
}
